import { render } from "./dorders.vue?vue&type=template&id=1dfd55e2&scoped=true"
const script = {}

import "./dorders.vue?vue&type=style&index=0&id=1dfd55e2&lang=scss&scoped=true"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dfd55e2"]])

export default __exports__